import React, { forwardRef, useState } from 'react';
import './ControlsBar.css';
import { FaRedo, FaSave, FaShare } from 'react-icons/fa';
import { FaX } from 'react-icons/fa6';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';

const ControlsBar = forwardRef(({
  onSave,
  onShare,
  onAcceptChar,
  onAcceptWord,
  onAcceptSuggestion,
  onRefetch,
  onDiscardSuggestion,
  onBrief,
  briefSet,
  onChange,
  currentText,
}, ref) => {
  const [layoutName, setLayoutName] = useState("default");

  const handleShift = () => {
    setLayoutName((prevLayoutName) => prevLayoutName === "default" ? "shift" : "default");
  };

  const handleNumbers = () => {
    setLayoutName((prevLayoutName) => prevLayoutName !== "numbers" ? "numbers" : "default");
  };

  const handleSymbols = () => {
    setLayoutName((prevLayoutName) => prevLayoutName !== "symbols" ? "symbols" : "default");
  };

  const handleABC = () => {
    setLayoutName("default");
  };

  const onKeyPress = (button) => {
    // if can vibrate, vibrate
    if (navigator.vibrate) {
      navigator.vibrate(20);
    }
  
    if (button === "{shift}" || button === "{capslock}") handleShift();
    if (button === "{numbers}") handleNumbers();
    if (button === "{symbols}") handleSymbols();
    if (button === "{abc}") handleABC();
    if (button === "{backspace}") {
      onChange(currentText.slice(0, -1));
    } else if (button === "{space}") {
      onChange(currentText + " ");
    } else if (button !== "{shift}" && button !== "{capslock}" && button !== "{numbers}" && button !== "{abc}" && button !== "{symbols}" && button !== "{backspace}" && button !== "{space}" && button !== "{enter}") {
      onChange(currentText + button);
    }
  };
  

  return (
    <div className="control-bar" ref={ref}>
    {/* There are no keyboard shortcuts on a phone, so everything the keys do
        on a desktop has to be a button here, the brief included: it is the
        one thing that changes what comes back, and it used to be reachable
        only with ctrl + b. */}
    <div className="control-bar-row">
      <button onClick={onAcceptChar}>letter</button>
      <button onClick={onAcceptWord}>word</button>
      <button onClick={onAcceptSuggestion}>all of it</button>
    </div>
    <div className="control-bar-row">
      <button onClick={onRefetch} aria-label="Another suggestion"><FaRedo /></button>
      <button onClick={onDiscardSuggestion} aria-label="Clear the suggestion"><FaX /></button>
      <button
        onClick={onBrief}
        className={`control-bar-brief${briefSet ? ' is-set' : ''}`}
      >
        brief{briefSet ? ' ·' : ''}
      </button>
      <button onClick={onSave} aria-label="Save"><FaSave /></button>
      <button onClick={onShare} aria-label="Share"><FaShare /></button>
    </div>
    <Keyboard
      onKeyPress={onKeyPress}
      mergeDisplay={true}
      layoutName={layoutName}
      layout={{
        default: [
          "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
          "q w e r t y u i o p",
          "a s d f g h j k l",
          "{shift} z x c v b n m , .",
          "{numbers} {space} {symbols} {backspace}"
        ],
        shift: [
          "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
          "Q W E R T Y U I O P",
          "A S D F G H J K L",
          "{shift} Z X C V B N M ! ?",
          "{numbers} {space} {symbols} {backspace}"
        ],
        numbers: [
          "1 2 3",
          "4 5 6",
          "7 8 9",
          "{abc} {space} {backspace}"
        ],
        symbols: [
          "! @ # $ % ^ & * ( )",
          "` ~ - _ = + { [ ] } \\ |",
          ": ; ' \" , < . > / ?",
          "{abc} {space} {backspace}"
        ]
      }}
      display={{
        "{numbers}": "123",
        "{ent}": "return",
        "{escape}": "esc ⎋",
        "{tab}": "tab ⇥",
        "{backspace}": "⌫",
        "{capslock}": "caps lock ⇪",
        "{shift}": "⇧",
        "{controlleft}": "ctrl ⌃",
        "{controlright}": "ctrl ⌃",
        "{altleft}": "alt ⌥",
        "{altright}": "alt ⌥",
        "{metaleft}": "cmd ⌘",
        "{metaright}": "cmd ⌘",
        "{abc}": "ABC",
        "{space}": "space",
        "{enter}": "↵",
        "{symbols}": "#+="
      }}
    />
  </div>

  );
});

export default ControlsBar;
